export default __webpack_public_path__ + "static/media/hero.eb29246b.jpg";